import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import VehicleStageGraph, { customerPriority, stagePriority } from '../modules/VehicleStageGraph';
import VehicleTabs from '../modules/VehicleTabs';
import { setCurrentStage, setSelectedStage, setVehicle } from '../redux/slices/vehicle';
import Page from '../components/Page/Page';
import InfoHeader from '../modules/InfoHeader';
import ActionsTabs from '../modules/CustomerDetailsSection/ActionsTabs';
import { caseService, getVehicle } from '../services/vehicles';
import VehicleStage from '../modules/VehicleStage';
import NextStep from '../modules/CustomerDetailsSection/NextStep';
import CasesList from '../modules/VehicleTabs/CasesList';

const Vehicle = () => {
  // use hooks
  const dispatch = useDispatch();
  const { reservationId } = useParams<{ reservationId: string }>();

  // local states
  const [cases, setCases] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [transactionErrors, setTransactionErrors] = useState<any>();
  const [retryDecisionPending, setRetryDecisionPending] = useState(false);

  // constants
  const tabs = [
    {
      id: 'DUE_TODAY',
      title: 'Due Today',
    },
    {
      id: 'UPCOMING',
      title: 'Upcoming Tasks',
    },
    {
      id: 'COMPLETED',
      title: 'Completed Tasks',
    },
  ];

  // case data
  const caseData = cases?.map?.((item: any) => {
    return {
      title: item?.caseType,
      date: `Last modified on: ${moment(item?.LastModifiedDate)?.format('MMM D, Y, hh:mm A')}`,
      secondDate: `Created on: ${moment(item?.openedDate)?.format('MMM D, Y, hh:mm A')}`,
      status: item?.status,
      sForceId: item?.sForceId,
    };
  });

  // fetching record
  const fetchRecord = useCallback(async () => {
    setCases([]);
    try {
      const resp = await caseService({ method: 'POST', data: { reservationId, langCode: 'en-us' } });
      setCases(resp?.data?.data);
    } catch (error) {
      console.log(error);
    }
  }, [reservationId]);

  // lifecycle hook
  useEffect(() => {
    console.log('Called');
    setTransactionErrors(false);
    if (reservationId) {
      fetchRecord();
      setLoading(true);
      getVehicle(reservationId).then((vehicle) => {
        dispatch(setVehicle(vehicle));
        dispatch(setCurrentStage(vehicle?.currentStage)); // setting current stage
        if (customerPriority?.[vehicle?.customerStage] > 0 && customerPriority?.[vehicle?.customerStage] < 5) {
          if (customerPriority?.[vehicle?.customerStage] === 1) dispatch(setSelectedStage('Registration')); // setting selected stage
          if (customerPriority?.[vehicle?.customerStage] === 2) dispatch(setSelectedStage('Pricing')); // setting selected stage
          if (customerPriority?.[vehicle?.customerStage] === 3 || customerPriority?.[vehicle?.customerStage] === 4)
            dispatch(setSelectedStage('Payments')); // setting selected stage
        } else {
          dispatch(setSelectedStage(vehicle?.currentStage === 'Vehicle Ready' ? 'Inspection' : vehicle?.currentStage)); // setting selected stage
        }
        setLoading(false);
      });
    }
  }, [reservationId, fetchRecord, dispatch]);

  console.log('Vehicle Stage', transactionErrors);

  return (
    <Page sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
      <Box>
        <InfoHeader setTransactionErrors={setTransactionErrors} retryDecisionPending={retryDecisionPending} />
        <Box sx={{ pt: 1, bgcolor: 'gray.10', minHeight: 'calc(100vh - 150px)' }}>
          <Grid container spacing={2}>
            <Grid item sm={12} md={6} lg={3}>
              <VehicleTabs loading={loading} />
            </Grid>
            <Grid item sm={12} md={6} lg={9}>
              <Box bgcolor="common.white" sx={{ borderTopLeftRadius: '8px', px: '30px', py: '15px' }}>
                <VehicleStageGraph
                  transactionErrors={transactionErrors}
                  setRetryDecisionPending={setRetryDecisionPending}
                  setTransactionErrors={setTransactionErrors}
                />
                <Grid container spacing={2} mt={2}>
                  <Grid item md={7}>
                    <VehicleStage />
                  </Grid>
                  <Grid item sm={12} md={5} m={0}>
                    {/* <NextStep /> */}
                    {/* <Grid item xs={12} pt={2}> */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography fontSize={20} fontWeight={500} sx={{ lineHeight: '24px' }}>
                        Cases
                      </Typography>
                    </Stack>
                    <CasesList cases={caseData} />
                    {/* </Grid> */}
                    {/* <ActionsTabs tabs={tabs} /> */}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Page>
  );
};

export default Vehicle;
